import dayjs from 'dayjs';
import { Document } from './types';
import { APP_VERSION, SOURCE } from '../../data/constants';
import { IS_GST_VALID } from '../../data/local-storage-constants';

export const addFileNameToDocuments = (docs: Document[] = []) => {
  return docs.map((doc: any) => ({
    ...doc,
    name: doc.url ? getFileNameFromUrl(doc.url) : '',
  }));
};

function getFileNameFromUrl(url: string) {
  const fileNameWithHash: any = url.split('/').pop() || '';
  const fileNameParts = fileNameWithHash.split('-');

  if (fileNameParts.length > 1) {
    fileNameParts.shift();
  }

  return fileNameParts.join('-');
}

export const isGSTSubmitted = () => {
  let isGSTValid = localStorage.getItem(IS_GST_VALID) || false;
  return isGSTValid === 'true';
};

export const calculateAge = (registrationDate: string): number => {
  const registrationDay = dayjs(registrationDate);
  const today = dayjs();
  return today.diff(registrationDay, 'year');
};

export const FLIPKART_UTM_PARAMS = {
  partnership: 'partnership',
  flipkart: 'flipkart',
  flipkart_seller_app: 'flipkart-seller-app',
};

export const isFlipkartFlow = () => {
  const utmSource = sessionStorage.getItem(SOURCE.utm_source) || '';
  const utmMedium = sessionStorage.getItem(SOURCE.utm_medium) || '';
  if (
    utmSource &&
    utmMedium &&
    utmSource === FLIPKART_UTM_PARAMS.partnership &&
    utmMedium === FLIPKART_UTM_PARAMS.flipkart
  ) {
    return true;
  }
  return false;
};

export const getFkSellerId = () => {
  return sessionStorage.getItem(SOURCE.fk_seller_id) || '';
};

export const getAppVersion = () => {
  return sessionStorage.getItem(APP_VERSION) || '';
};
